// Picture dialogs: native <dialog> provides keyboard activation and focus
// handling.
// (The header menu is the shared menu9 - see menu-init in main.ts.)
document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const trigger = target.closest<HTMLAnchorElement>('[data-picture-dialog]');
    if (trigger) {
        const dialog = document.getElementById(trigger.dataset.pictureDialog ?? '');
        if (dialog instanceof HTMLDialogElement) {
            event.preventDefault();
            dialog.showModal();
        }
    }
    const dialog = target.closest('dialog');
    if (dialog instanceof HTMLDialogElement && (target.closest('[data-dialog-close]') || target === dialog)) {
        dialog.close();
    }
});
